import { inject } from '@vercel/analytics'
import { useEffect } from 'react'

let started = false

/**
 * Strumenti di misurazione. Va montato solo dopo il consenso (vedi <ConsentGate> in App).
 */
export default function Analytics() {
  useEffect(() => {
    if (started) return
    started = true

    // Funziona solo se il sito è servito da Vercel: altrove lo script non esiste
    inject()
  }, [])

  return null
}
